// --------------------------------------------------------------
// Created On: 2025-11-05
// Author: Marco Serrano
//
// Last Modified: 2025-11-07
// Modified By: Marco Serrano
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import styles from "./SaveQuoteModal.module.scss";

// Modal component for Saving a quote and determining if we clear the cart or not
export default function SaveChangesModal(props: Props): Component {
  return (
    <Modal
      show={props.showModal}
      onHide={() => props.onClose()}
      backdropClassName={`${styles.modal} ${styles.backdrop}`}
      style={{ zIndex: "var(--super-modal-z-index)" }}
      animation
      centered
    >
      <ModalHeader>
        <h5>Save Quote</h5>
      </ModalHeader>
      <ModalBody>
        <p>Save the contents of your shopping cart as a sales quote by providing a name for the sales quote below.</p>
        <br />
        <strong>Quoted prices are valid for 30 days from quote creation.</strong>
        <input
          className="form-control my-3"
          data-test="quote-name-input"
          type="text"
          placeholder="Quote Name"
          value={props.quoteName}
          onChange={(e) => props.onChangeQuoteName(e.target.value)}
        />
        <div className="row align-items-center px-3">
          <div className="col-auto form-check">
            <input
              className="form-check-big form-check-input"
              data-test="should-clear-cart-checkbox-input"
              type="checkbox"
              checked={props.shouldClearCart}
              onChange={() => props.onChangeShouldClearCart(!props.shouldClearCart)}
              id="shouldClearCartCheckbox"
            />
          </div>
          <div className="col">
            <label className="form-check-label" htmlFor="shouldClearCartCheckbox">
              Clear shopping cart after quote creation.
            </label>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        {props.onSave !== undefined && (
          <button
            type="button"
            className={`${styles.button} btn btn-primary`}
            data-dismiss="modal"
            onClick={() => {
              if (props.onSave !== undefined) {
                props.onSave();
              }
            }}
          >
            <span className="d-none d-md-inline">Save Changes</span>
            <span className="d-inline d-md-none">Save</span>
          </button>
        )}

        <button type="button" className={`${styles.button} btn btn-secondary`} onClick={() => props.onClose()}>
          Cancel
        </button>
      </ModalFooter>
    </Modal>
  );
}

interface Props {
  quoteName: string;
  shouldClearCart: boolean;
  showModal: boolean;
  onClose: () => void;
  onSave: () => void;
  onChangeQuoteName: (quoteName: string) => void;
  onChangeShouldClearCart: (shouldClearCart: boolean) => void;
}
